var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopwatchOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2871 11.7071C17.8966 11.3166 17.2634 11.3166 16.8729 11.7071L14.0445 14.5355C13.654 14.9261 13.654 15.5592 14.0445 15.9497C14.435 16.3403 15.0682 16.3403 15.4587 15.9497L18.2871 13.1213C18.6776 12.7308 18.6776 12.0976 18.2871 11.7071Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5875 2C11.0352 2 10.5875 2.44772 10.5875 3C10.5875 3.55228 11.0352 4 11.5875 4H13V6.04938C7.94668 6.5511 4 10.8147 4 16C4 21.5228 8.47715 26 14 26C19.5228 26 24 21.5228 24 16C24 13.5921 23.149 11.3831 21.7313 9.6571L23.1371 8.25133C23.5276 7.8608 23.5276 7.22764 23.1371 6.83711C22.7466 6.44659 22.1134 6.44659 21.7229 6.83711L20.3145 8.24546C18.8354 7.03957 17.0048 6.24842 15 6.04938V4H16.4125C16.9648 4 17.4125 3.55228 17.4125 3C17.4125 2.44772 16.9648 2 16.4125 2H11.5875ZM6 16C6 11.5817 9.58172 8 14 8C18.4183 8 22 11.5817 22 16C22 20.4183 18.4183 24 14 24C9.58172 24 6 20.4183 6 16Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopwatchOutline);
export default __webpack_public_path__ + "static/media/stopwatch_outline.dc7ab4fb0b100cdeb70c6f2fac8fd094.svg";
export { ForwardRef as ReactComponent };